import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"
import { ApiStatus } from "services/common"

const defaultURL = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/rbo/availability`

export interface UpdateAvailabilityDataResponse extends AxiosResponse {
  data: {
    apiStatus: ApiStatus
    message: string
  }
}

export interface UpdateAvailabilityDataRequestData {
  unitId: string
  pmcId: string
  minLos: number
  maxLos: number
}
export interface UpdateAvailabilityDataRequest
  extends Partial<AxiosRequestConfig> {
  data: UpdateAvailabilityDataRequestData
}

export function updateAvailabilityDataApi(
  {
    data,
    method = "post",
    url = defaultURL,
    ...config
  }: UpdateAvailabilityDataRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<UpdateAvailabilityDataResponse> {
  return axiosInstance({
    method,
    url,
    data,
    ...config,
  }) as Promise<UpdateAvailabilityDataResponse>
}
